
import { ConvertLocalToUtc } from "commonFunctions/commonFunctions";
import * as c from "utils/constants/constants";

export const getQueryFilters = () => {
    var all_filters = JSON.parse(localStorage.getItem(c.FILTER));
    var categories = [];
    var locations = [];
    var status = [];
    var flags = [];
    if (all_filters?.doc_cat !== "All" && all_filters?.doc_cat?.length > 0) {
      all_filters.doc_cat.map((cat, i) => {
        if (cat.isChecked === true && cat.name !== "Select All")
          categories.push(cat.name);
      });
    }
    if (all_filters?.doc_loc !== "All" && all_filters?.doc_loc?.length > 0) {
      all_filters.doc_loc.map((loc, i) => {
        if (loc.isChecked === true && loc.name !== "Select All")
          locations.push(loc.name);
      });
    }
    if (all_filters?.status && all_filters?.status?.length > 0) {
      all_filters.status.map((st, i) => {
        if (st.isChecked === true) status.push(st.name);
      });
    }
    let include_tag_less_docs = all_filters.include_tag_less_docs;
    var query = {
      selected_category: all_filters?.doc_cat === "All" ? "All" : categories,
      selected_status: status,
      selected_locations: all_filters?.doc_loc === "All" ? "All" : locations,
      selected_tags: all_filters?.flag_data,
      include_tag_less_docs: include_tag_less_docs || false,
      from_date: all_filters?.fromDate ? ConvertLocalToUtc({ date: all_filters.fromDate, format: "MM-DD-YYYY HH:mm:ss", startOf: "day" }) : "",
      to_date: all_filters?.toDate ? ConvertLocalToUtc({ date: all_filters.toDate, format: "MM-DD-YYYY HH:mm:ss", endOf: "day" }) : "",
      search_string: all_filters?.search || "",
      sorting: {
        sort_column: all_filters?.sort_key,
        is_asc: all_filters?.sort_order,
      },
      is_stat: all_filters?.isStat,
      failure_description: all_filters?.failure_description
    };
    return query;
}